import {Chip} from "@mui/material";
import {Link as RouterLink} from 'react-router-dom';
import {PATH_DASHBOARD} from '../../../routes/paths';
import useLocales from '../../../hooks/useLocales';
import useAuth from "../../../hooks/useAuth";
import Iconify from "../../../components/Iconify";
import {availableCreditBalance} from '../../../utils/creditBalance';
// components

// ----------------------------------------------------------------------

export default function CreditsIcon() {
    const {translate} = useLocales();
    const {credits} = useAuth();
    const availableCredits = availableCreditBalance(credits);

    return (
        <>
            <Chip component={RouterLink} to={PATH_DASHBOARD.buyCredits} clickable aria-label={`${translate('label.credits', {credits: availableCredits})}. Comprar créditos`} data-tut="credits" icon={<Iconify icon={'fa:dollar'}/>} label={translate('label.credits', {credits: availableCredits})} color="primary" variant="filled" sx={{pl:1}}/>
        </>
    );
}
